if (!customElements.get("cart-drawer")) {
  class CartDrawer extends HTMLElement {
    constructor() {
      super();
      this.overlay = this.querySelector(".ajaxcart_overlay");
      this.buttonClose = this.querySelector(".btn-close");
      this.buttonCheckout = this.querySelector(".btn-checkout");
      this.buttonContinue = this.querySelector(".btn-continue");
      this.cartContainer = this.querySelector("#ajaxCart");
      this.cartHeader = this.cartContainer.querySelector(".cart-header");
      this.subTotal = this.cartContainer.querySelector(".subtotal");

      this.init();
    }

    updateCartInfo(cart) {
      const _this = this;
      document.querySelectorAll(".cart-count-bubble").forEach(function (obj) {
        if (cart.item_count <= 0) {
          obj.remove();
        } else {
          obj.innerHTML = cart.item_count;
          _this.subTotal.innerHTML = Shopify.formatMoney(
            cart.items_subtotal_price
          );
        }
      });
    }

    updateLineitem(lineitem, qty) {
      var datas = {};
      var qty = qty;
      datas[lineitem.getAttribute("data-variantid")] = qty;
      var updates = {};
      updates["updates"] = datas;
      const _this = this;

      console.log(datas);

      fetch("/cart/update.js", {
        method: "POST",
        headers: new Headers({ "content-type": "application/json" }),
        body: JSON.stringify(updates),
      })
        .then((res) => {
          return res.json();
        })
        .then((res1) => {
          console.log(res1);

          if (qty <= 0) {
            lineitem.style.opacity = 0;
            setTimeout(function () {
              lineitem.remove();

              if (res1.item_count <= 0) {
                _this.cartContainer.classList.add("empty");
              }
            }, 500);
          } else {
            const items = lineitem
              .querySelector(".item-price")
              .querySelectorAll(".ss-price-trigger");
            items.forEach((item) => {
              const price = parseInt(item.getAttribute("data-unit-price"), 10);
              item.innerHTML = Shopify.formatMoney(price * qty);
            });
          }

          this.updateCartInfo(res1);

          console.log("Here Again");
        });
    }

    init() {
      var header_height = document.querySelector(
        "#shopify-section-header"
      ).offsetHeight;
      this.cartHeader.style.height = header_height + "px";
      console.log(this.cartHeader, header_height);
      const _this = this;

      this.overlay.addEventListener("click", function (e) {
        document.querySelector("body").classList.remove("ajaxcart-open");
      });

      this.buttonClose.addEventListener("click", function (e) {
        document.querySelector("body").classList.remove("ajaxcart-open");
      });

      this.buttonContinue.addEventListener("click", function (e) {
        _this.buttonClose.click();
      });

      document.querySelectorAll(".header__icon--cart").forEach(function (obj) {
        obj.addEventListener("click", function (e) {
          e.preventDefault();
          document.querySelector("body").classList.add("ajaxcart-open");
        });
      });

      this.addEventListener("change", function (e) {
        var target = e.target;
        var lineitem = target.closest(".cart-item");
        var qty_inp = lineitem.querySelector(".qty-input");
        var qty = parseInt(qty_inp.value);

        if (target.classList.contains("qty-input")) {
          console.log("Here");
          // document
          //   .getElementById("ajaxCart")
          //   .querySelectorAll(".quantity__button")
          //   .setAttribute("disabled", "disabled");
          this.updateLineitem(lineitem, qty);
        }
      });

      this.addEventListener("click", function (e) {
        var target = e.target;

        if (
          !target.classList.contains("qty-plus") &&
          !target.classList.contains("qty-minus") &&
          !target.classList.contains("item-remove")
        ) {
          return;
        }

        var lineitem = target.closest(".cart-item");
        var qty_inp = lineitem.querySelector(".qty-input");

        if (target.classList.contains("qty-plus")) {
          var qty = parseInt(qty_inp.value);
          qty_inp.value = qty + 1;
          this.updateLineitem(lineitem, qty);
        }

        if (target.classList.contains("qty-minus")) {
          var qty = parseInt(qty_inp.value);
          if (qty <= 0) {
            return;
          }

          qty_inp.value = qty - 1;
          this.updateLineitem(lineitem, qty);
        }

        if (target.classList.contains("item-remove")) {
          //qty_inp.value = 0;
          this.updateLineitem(lineitem, 0);
        }
      });
    }
  }

  customElements.define("cart-drawer", CartDrawer);
}
